import { GhostIconButton, Stack, Text } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { Code } from "../code/Code";

interface Props {
  claims: object;
  testID: string;
  title: string;
}

export const Claims = (props: Props) => {
  const claims = JSON.stringify(props.claims, null, 2);
  const { t } = useTranslation();

  return (
    <Stack gap="space-0" data-testid={props.testID}>
      <Stack orientation="horizontal" gap="space-0">
        <Text as="h5">{props.title}</Text>
        <GhostIconButton
          icon="content_copy"
          size="small"
          aria-label={t(`Copy claims to clipboard`)}
          onPress={() => navigator.clipboard.writeText(claims)}
        />
      </Stack>
      <Code language="json" testId={`${props.testID}-content`}>
        {claims}
      </Code>
    </Stack>
  );
};
